export default [
    {
        path: 'esus-gerenciamento-envio',
        component: () => import(
            /* webpackChunkName: 'integracao-esus-gerenciamento-envio' */
            '@/views/integracao/esus/gerenciamento-envio/Index'
        ),
        redirect: 'esus-gerenciamento-envio/index',
        children: [
            {
                name: 'integracao-esus-gerenciamento-envio-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'integracao-esus-gerenciamento-envio' */
                    '@/views/integracao/esus/gerenciamento-envio/List.vue'
                ),
            },
        ],
    },
]